import { render, staticRenderFns } from "./Pekerjaan.vue?vue&type=template&id=55357cba"
import script from "./Pekerjaan.vue?vue&type=script&lang=js"
export * from "./Pekerjaan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports